import { render, staticRenderFns } from "./ActivityTimeLineItemUpdate.vue?vue&type=template&id=aaa9c2f2&"
import script from "./ActivityTimeLineItemUpdate.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItem})
